<ng-container *transloco="let t;">
  <form (submit)="onSubmit()" novalidate>
    <app-list-view [title]="t('common.labels.templates')" [messages]="messages" [loading]="loading">

      <div buttons>
        <ng-container *ngIf="inEdit !== true">
          <button withRight="admin.planning-settings.show-settings" pButton (click)="onReload()" type="button"
            icon="pi pi-refresh" class="p-button-sm p-button-secondary p-button-outlined p-mb-2"
            aria-label="{{ t('common.labels.reload_list') }}" pTooltip="{{ t('common.labels.reload_list') }}" tooltipPosition="left"></button>
          <button *ngIf="models.length > 0" withRight="admin.planning-settings.save-settings-templates" pButton (click)="onEdit()"
            type="button" icon="pi pi-pencil" label="{{ t('common.labels.edit') }}"
            class="p-button-sm p-ml-2 p-mb-2"></button>
        </ng-container>
        <ng-container *ngIf="inEdit === true">
          <app-form-buttons [submitting]="submitting" (cancelled)="onCancel()"></app-form-buttons>
        </ng-container>
      </div>

      <div table>
        <p-table [value]="models" styleClass="p-datatable-sm" [paginator]="false" [rows]="10000" stateStorage="local"
          stateKey="template-settings-templates-list">
          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="model.name">{{ t('common.labels.name') }}
                <p-sortIcon field="model.name"></p-sortIcon>
              </th>
              <th>{{ t('common.labels.note') }}</th>
              <th>{{ t('common.labels.active') }}</th>
              <th>{{ t('common.labels.observer_short') }}</th>
              <th>{{ t('common.labels.observer_gem_short') }}</th>
              <th>{{ t('common.labels.hiringdays') }}</th>
              <th>{{ t('common.labels.candidate') }}</th>
              <th>{{ t('common.labels.prio_mod') }}</th>
              <th>{{ t('common.labels.monthly_limit_total') }}</th>
              <th>{{ t('common.labels.prebriefing') }}</th>
              <th>{{ t('common.labels.prebriefing_time') }}</th>
              <th>{{ t('common.labels.lqg_position') }}</th>
              <th>{{ t('common.labels.last_changed') }}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-model>
            <tr>
              <td>{{ model.model.name }}</td>
              <td>
                <app-form-control [noMargin]="true" [control]="model.form.get('note')" [type]="'input'"
                  [showLabel]="false"></app-form-control>
              </td>
              <td>
                <app-form-control [noMargin]="true" [control]="model.form.get('active')" [type]="'checkbox'"
                  [showLabel]="false"></app-form-control>
              </td>
              <td>
                <app-form-control [noMargin]="true" [control]="model.form.get('min_observers')" [type]="'select'"
                [options]="options['observers_amount']" [showLabel]="false"></app-form-control>
              </td>
              <td>
                <app-form-control [noMargin]="true" [control]="model.form.get('has_observer_gem')" [type]="'select'"
                  [options]="options['hr_observer_mode']" [showLabel]="false"></app-form-control>
              </td>
              <td>
                <app-form-control [noMargin]="true" [control]="model.form.get('hiringdays')" [type]="'checkbox'"
                  [showLabel]="false"></app-form-control>
              </td>
              <td>
                <app-form-control [noMargin]="true" [control]="model.form.get('candidatetype')" [type]="'select'"
                  [options]="options['candidatetype']" [showLabel]="false"></app-form-control>
              </td>
              <td>
                <div class="p-grid p-fluid">
                  <div class="p-col-6" style="padding-top: 15px;">
                    <i *ngIf="model.form.get('priomod').value" class="pi pi-check" [pTooltip]="model.getPrioModTooltip()" [escape]="false"></i>
                  </div>
                  <div class="p-col-6 p-text-right">
                    <ng-container *ngIf="inEdit === true" [ngSwitch]="model.model.users?.length">
                      <span *ngSwitchCase="0" [pTooltip]="t('template_settings.no_moderators_assigned')">
                        <button (click)="editPrioMod(model)" type="button" pButton icon="pi pi-pencil"
                          disabled class="p-button-sm p-button-outlined p-button-secondary"></button>
                      </span>
                      <span *ngSwitchDefault>
                        <button (click)="editPrioMod(model)" type="button" pButton icon="pi pi-pencil"
                          class="p-button-sm"></button>
                      </span>
                    </ng-container>
                  </div>
                </div>
              </td>
              <td>
                <i *ngIf="hasMonthlyLimits(model)" class="pi pi-check p-mr-1"></i>
                <i *ngIf="!hasMonthlyLimits(model)" class="pi pi-minus p-mr-1" style="opacity: 0.3;"></i>
                <button *ngIf="inEdit === true" (click)="openMonthlyLimitsDialog(model)" type="button" pButton
                  icon="pi pi-pencil" class="p-button-sm p-button-secondary p-button-outlined ml-1"></button>
              </td>
              <td>
                <app-form-control [noMargin]="true" [control]="model.form.get('prebriefing')" [type]="'checkbox'"
                  [showLabel]="false"></app-form-control>
              </td>
              <td>
                <app-form-control [noMargin]="true" [control]="model.form.get('prebriefing_time')" [type]="'input'"
                  [showLabel]="false"></app-form-control>
              </td>
              <td>
                <app-form-control [noMargin]="true" [control]="model.form.get('lqgposition')" [type]="'checkbox'"
                  [showLabel]="false"></app-form-control>
              </td>
              <td>
                {{ model.model.getLastChanged() }}
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td class="no-data" colspan="13">{{ t('common.labels.no_data') }}</td>
            </tr>
          </ng-template>
        </p-table>
      </div>

    </app-list-view>
  </form>

  <p-dialog header="{{ t('common.labels.prio_mod') }} {{ t('common.labels.for') }} {{ openedTemplate?.model?.name }}"
    [(visible)]="openedTemplate" [draggable]="false" [resizable]="false" modal="true" [style]="{width: '50vw'}">
    <div class="modarator-list">
      <p-table [value]="moderators" styleClass="p-datatable-sm" [paginator]="false" [rows]="10000">
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="fullname">{{ t('common.labels.moderator') }}
              <p-sortIcon field="fullname"></p-sortIcon>
            </th>
            <th pSortableColumn="email">{{ t('common.labels.email') }}
              <p-sortIcon field="email"></p-sortIcon>
            </th>
            <th>{{ t('common.labels.external') }}</th>
            <th>{{ t('common.labels.prio') }}</th>
            <th></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-moderator>
          <tr>
            <td>{{ moderator.fullname }}</td>
            <td>{{ moderator.email }}</td>
            <td><i *ngIf="moderator.isExternalModerator" class="pi pi-check"></i></td>
            <td>
              <p-inputNumber [formControl]="moderator.control" type="text" [showButtons]="true" buttonLayout="horizontal"
                mode="decimal" [minFractionDigits]="0" [maxFractionDigits]="0" min="0" max="6"
                incrementButtonIcon="pi pi-plus" decrementButtonIcon="pi pi-minus"
                incrementButtonClass="p-button-secondary" decrementButtonClass="p-button-secondary"></p-inputNumber>
            </td>
            <td class="p-text-right" style="min-width: 40px;">
              <i *ngIf="moderator.control.value > 0" (click)="moderator.control.setValue('')" class="pi pi-trash"></i>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td class="no-data" colspan="4">{{ t('common.labels.no_data') }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
    <p-footer>
      <button pButton (click)="hideModerators()" type="button" label="{{ t('common.labels.cancel') }}"
        class="p-button-outlined p-button-secondary"></button>
      <button pButton (click)="saveModerators()" type="button" label="{{ t('common.ok') }}"
        class="p-button-success"></button>
    </p-footer>
  </p-dialog>

  <p-dialog
    header="{{ t('common.labels.monthly_limits_total') }} {{ t('common.labels.for') }} {{ openedMonthlyEntry?.templateName }}"
    [(visible)]="openedMonthlyEntry"
    [draggable]="false"
    [resizable]="false"
    modal="true"
    [style]="{width: '40vw'}">

    <ng-container *ngIf="openedMonthlyEntry">

      <!-- Abschnitt 1: aktueller + 11 zukünftige Monate -->
      <p-table [value]="openedMonthlyEntry.futureMonths" styleClass="p-datatable-sm" [paginator]="false">
        <ng-template pTemplate="header">
          <tr>
            <th>{{ t('common.labels.month') }}</th>
            <th>{{ t('common.labels.limit') }}</th>
            <th>{{ t('common.labels.booked') }}</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-entry>
          <tr>
            <td>{{ entry.label }}</td>
            <td>
              <p-inputNumber [formControl]="entry.limit" [showButtons]="false"
                mode="decimal" [minFractionDigits]="0" [maxFractionDigits]="0" [min]="0"
                placeholder="—" (onBlur)="clampLimitToBooked(entry)"></p-inputNumber>
            </td>
            <td [style.color]="entry.limit.value !== null && entry.booked >= entry.limit.value ? 'red' : null"
                [style.fontWeight]="entry.limit.value !== null && entry.booked >= entry.limit.value ? 'bold' : null">
              {{ entry.booked }}
            </td>
          </tr>
        </ng-template>
      </p-table>

      <!-- Abschnitt 2: vergangene Monate (aufklappbar) -->
      <div *ngIf="openedMonthlyEntry.pastMonths.length > 0" class="p-mt-3">
        <button pButton type="button"
          [icon]="showPastMonths ? 'pi pi-chevron-up' : 'pi pi-chevron-down'"
          [label]="t('common.labels.past_months')"
          (click)="showPastMonths = !showPastMonths"
          class="p-button-text p-button-secondary p-button-sm"></button>

        <p-table *ngIf="showPastMonths" [value]="openedMonthlyEntry.pastMonths"
          styleClass="p-datatable-sm" [paginator]="false" class="p-mt-2">
          <ng-template pTemplate="header">
            <tr>
              <th>{{ t('common.labels.month') }}</th>
              <th>{{ t('common.labels.booked_slash_limit') }}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-entry>
            <tr>
              <td>{{ entry.label }}</td>
              <td>
                <!-- kein Limit gesetzt -->
                <span *ngIf="entry.originalLimit === null">
                  {{ t('common.labels.booked_count', { booked: entry.booked }) }}
                </span>
                <!-- Limit gesetzt, < 80% -->
                <span *ngIf="entry.originalLimit !== null && entry.booked / entry.originalLimit < 0.8">
                  {{ t('common.labels.booked_of_total', { booked: entry.booked, total: entry.originalLimit }) }}
                </span>
                <!-- ≥ 80% aber noch nicht voll — orange -->
                <span *ngIf="entry.originalLimit !== null && entry.booked / entry.originalLimit >= 0.8 && entry.booked < entry.originalLimit"
                  style="color: orange;">
                  {{ t('common.labels.booked_of_total', { booked: entry.booked, total: entry.originalLimit }) }}
                </span>
                <!-- Limit erreicht — rot -->
                <span *ngIf="entry.originalLimit !== null && entry.booked >= entry.originalLimit"
                  style="color: red;">
                  {{ t('common.labels.booked_of_total', { booked: entry.booked, total: entry.originalLimit }) }}
                </span>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>

    </ng-container>

    <p-footer>
      <button pButton (click)="closeMonthlyLimitsDialog()" type="button" [label]="t('common.labels.cancel')"
        class="p-button-outlined p-button-secondary"></button>
      <button pButton (click)="saveMonthlyLimitsDialog()" type="button" [label]="t('common.ok')"
        class="p-button-success"></button>
    </p-footer>
  </p-dialog>
</ng-container>
